<ion-app>
  <ion-router-outlet></ion-router-outlet>

  @if (stage !== 'production') {
    <div class="stage">{{ stage }}</div>
  }
</ion-app>
